import React from 'react';

const ReportTaskPage = React.lazy(() => import('pages/ReportTask/page/ReportTaskPage'));

const ReportTaskRoutes = [
  {
    path: '/report-task',
    exact: true,
    name: 'Báo cáo công việc',
    function: 'RECEIVESLIP_VIEW',
    component: ReportTaskPage,
  },
];

export default ReportTaskRoutes;
